import { Box, Button, Text } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { quizStarted } from "../../redux/actions/action";
import { loadQuizQuestions } from "../../redux/api/apiCalls";
import { CheckIcon } from "@chakra-ui/icons"


export default function QuizDetails({ id, title, date, questions, attemptsLeft, topicId }) {
    const dispatch = useDispatch()
    const history = useHistory()

    const clickHandler = () => {
        dispatch(loadQuizQuestions(id))
        dispatch(quizStarted())
        history.push({
            pathname:'/test-attempt',
            state:{attemptsLeft:attemptsLeft}
            })
    }

    return (
        <Box
            d='flex'
            justifyContent='space-between'
            alignItems='center'
            width='100%'
            py='1rem'
            position='relative'
            // px='1.5rem'
        >
            <Box d='flex' justifyContent='flex-start' alignItems='center' pointerEvents='none'>
                <Box
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    d='flex'
                    flexDir='column'
                    justifyContent='center'
                    alignItems='flex-start'
                    flexGrow='1'
                >
                    <Text fontWeight='700' fontSize={['8px', '12px', '16px', '16px']} color='#333333'>{title}</Text>
                    <Text fontWeight='400' fontSize={['8px', '11px', '13px', '13px']} color="#1B1A1AB2"> {date && `${date} | `} {questions} {questions > 1 ? `Questions` : `Question`}</Text>
                    { attemptsLeft && !topicId && <Text fontWeight='400' fontSize={['8px', '11px', '13px', '13px']} color="#1B1A1AB2">No. of attempts left : {attemptsLeft} </Text> }
                </Box>
            </Box>
            <Button
                p={['2px 8px', '3px 9px', '6px 18px', '8px 20px']}
                bg='#3E59DE'
                _hover={{ bg: "#3750c6" }}
                transition='opacity 200ms ease'
                borderRadius='10px'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                fontWeight='800'
                fontSize={['8px', '8px', '10px', '11px']}
                color='#FFFFFF'
                textTransform='uppercase'
                disabled={!attemptsLeft || attemptsLeft === 0}
                onClick={clickHandler}
            >
                {attemptsLeft && attemptsLeft > 0 ? 'Start' : <CheckIcon />}
            </Button>
            <Box
                width='75%'
                height='1px'
                bg='rgba(255, 255, 255, 0.2)'
                position='absolute'
                bottom='0'
                right='5'
            ></Box>
        </Box>
    )
}